module.exports = __webpack_public_path__ + "static/media/musictownMobile.410cd1c0.png";